import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { loadState } from './LocalStorage';
const middleware = [thunk];

const persistedState = loadState();

var initialState = persistedState != null
? persistedState
: {};

if(initialState.tickets != null ){
  // Clear all cached tickets on reload to prevent stale data flash.
  // Fresh data arrives via fetchTickets() ~200-500ms after listeners start.
  initialState.tickets.tickets = []
  initialState.tickets.activeTicketId = null
  initialState.tickets.callTickets = []
  initialState.tickets.transferTickets = []
  initialState.tickets.activeManagementTicketId = null
  initialState.tickets.latestTicket = null
  initialState.tickets.ticketsFetchedStatus = 0
}
if(initialState.sessions != null ){
  initialState.sessions.sessions = []
}
if(initialState.customers != null ){
  initialState.customers.customers = []
}

if( Object.keys(initialState).length ){ 

  // settings — never rehydrate an open modal. On reload tickets +
  // activeManagementTicketId are cleared, so a persisted open TicketManagement
  // modal would render against a missing ticket and crash the app.
  if( initialState.settings != null ){
    initialState.settings.modal = { visible: 0, content: null, modalType: 1 };
  }

  // management
  initialState.auth.appStatus = 0;
  initialState.auth.tokenStatus = -1;
  initialState.auth.reloadAppStatus = 0;
  initialState.auth.featureFlags = { slaBreach: false };

  // generic
  initialState.organizations.listenOrganizationsStart = 0;
  initialState.users.listenUsersStart = 0;
  initialState.branches.listenBranchesStart = 0;
  initialState.misc.listenTownsStart = 0;
  initialState.misc.listenRegionsStart = 0;
  initialState.misc.listenCountriesStart = 0;

  // QM
  initialState.services.listenServicesStart = 0;
  initialState.services.listenServiceSubscriptionsStart = 0;
  initialState.services.listenSupportDesksStart = 0;
  initialState.services.listenPriorityCustomersStart = 0;
  initialState.services.listenPriorityCustomerSubscriptionsStart = 0;
  initialState.services.listenServiceWaitingTimesStart = 0;

  // tickets
  initialState.tickets.listenTicketsStart = 0;
  initialState.tickets.listenCallTicketsStart = 0;
  initialState.tickets.listenTransferTicketsStart = 0;
  initialState.tickets.listenTicketsCount = 0;
  initialState.tickets.listenTransferTicketsCount = 0;
  initialState.tickets.latestTicket = null;
  
  // customers
  initialState.customers.listenCustomersStart = 0;

  // sessions
  initialState.sessions.sessionsFetchedStatus = 0;
  initialState.sessions.listenSessionsStart = 0;
  initialState.sessions.sessionSavedToDB = 0;
  initialState.sessions.sessionStatus = -1;

  // form builder
  initialState.fb.listenOptionsStart = 0;
  initialState.fb.listenOptionTypesStart = 0;

}

let composeEnhancer = "";
if (Number(process.env.REACT_APP_REDUX_DEVTOOLS_EXTENSION )){
  composeEnhancer = compose(
    applyMiddleware(...middleware),
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
}

else {
  composeEnhancer = compose(
    applyMiddleware(...middleware)
  )
}

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancer
);

export default store;
